export const airports = [
    {
        "id": 1,
        "iata": "ABD",
        "country": "IRAN",
        "city": "Abadan",
        "name": "Ayatollah Jami International Airport",
    },
    {
        "id": 3,
        "iata": "AEU",
        "country": "IRAN",
        "city": "Abu Musa Island",
        "name": "Abu Musa Airport",
    },
    {
        "id": 4,
        "iata": "AWZ",
        "country": "IRAN",
        "city": "Ahvaz",
        "name": "Ahvaz International Airport",
    },
    {
        "id": 5,
        "iata": "AJK",
        "country": "IRAN",
        "city": "Arak",
        "name": "Arak International Airport",
    },
    {
        "id": 6,
        "iata": "ADU",
        "country": "IRAN",
        "city": "Ardabil",
        "name": "Ardabil Airport",
    },
    {
        "id": 7,
        "iata": "YEH",
        "country": "IRAN",
        "city": "Asalouyeh",
        "name": "Asalouyeh Airport",
    },
    {
        "id": 8,
        "iata": "PGU",
        "country": "IRAN",
        "city": "Asalouyeh",
        "name": "Persian Gulf Airport",
    },
    {
        "id": 9,
        "iata": "BBL",
        "country": "IRAN",
        "city": "Babolsar",
        "name": "Babolsar Airport",
    },
    {
        "id": 10,
        "iata": "IAQ",
        "country": "IRAN",
        "city": "Bahregan",
        "name": "Bahregan Airport",
    },
    {
        "id": 11,
        "iata": "BXR",
        "country": "IRAN",
        "city": "Bam",
        "name": "Bam Airport",
    },
    {
        "id": 12,
        "iata": "BND",
        "country": "IRAN",
        "city": "Bandar Abbas",
        "name": "Bandar Abbas International Airport",
    },
/*    {
        "id": 13,
        "iata": "HDR",
        "country": "IRAN",
        "city": "Bandar Abbas",
        "name": "Havadarya Airport",
    },*/
    {
        "id": 14,
        "iata": "BDH",
        "country": "IRAN",
        "city": "Bandar Lengeh",
        "name": "Bandar Lengeh Airport",
    },
    {
        "id": 16,
        "iata": "XBJ",
        "country": "IRAN",
        "city": "Birjand",
        "name": "Birjand International Airport",
    },
    {
        "id": 17,
        "iata": "BJB",
        "country": "IRAN",
        "city": "Bojnord",
        "name": "Bojnord Airport",
    },
    {
        "id": 18,
        "iata": "BUZ",
        "country": "IRAN",
        "city": "Bushehr",
        "name": "Bushehr Airport",
    },
    {
        "id": 19,
        "iata": "ZBR",
        "country": "IRAN",
        "city": "Chabahar",
        "name": "Konarak Airport",
    },
    {
        "id": 21,
        "iata": "DEF",
        "country": "IRAN",
        "city": "Dezful",
        "name": "Dezful Airport",
    },
    {
        "id": 24,
        "iata": "FAZ",
        "country": "IRAN",
        "city": "Fasa",
        "name": "Fasa Airport",
    },
    {
        "id": 26,
        "iata": "GCH",
        "country": "IRAN",
        "city": "Gachsaran",
        "name": "Gachsaran Airport",
    },
    {
        "id": 29,
        "iata": "GBT",
        "country": "IRAN",
        "city": "Gorgan",
        "name": "Gorgan Airport",
    },
    {
        "id": 30,
        "iata": "HDM",
        "country": "IRAN",
        "city": "Hamadan",
        "name": "Hamadan Airport",
    },
    {
        "id": 31,
        "iata": "IIL",
        "country": "IRAN",
        "city": "Ilam",
        "name": "Ilam Airport",
    },
    {
        "id": 32,
        "iata": "IHR",
        "country": "IRAN",
        "city": "Iranshahr",
        "name": "Iranshahr Airport",
    },
    {
        "id": 33,
        "iata": "IFN",
        "country": "IRAN",
        "city": "Isfahan",
        "name": "Shahid Beheshti International",
    },
    {
        "id": 34,
        "iata": "JAR",
        "country": "IRAN",
        "city": "Jahrom",
        "name": "Jahrom Airport",
    },
    {
        "id": 35,
        "iata": "JSK",
        "country": "IRAN",
        "city": "Jask",
        "name": "Jask Airport",
    },
    {
        "id": 36,
        "iata": "JYR",
        "country": "IRAN",
        "city": "Jiroft",
        "name": "Jiroft Airport",
    },
    {
        "id": 37,
        "iata": "KLM",
        "country": "IRAN",
        "city": "Kalaleh",
        "name": "Kalaleh Airport",
    },
    {
        "id": 38,
        "iata": "KNR",
        "country": "IRAN",
        "city": "Kangan",
        "name": "Jam Airport",
    },
    {
        "id": 39,
        "iata": "PYK",
        "country": "IRAN",
        "city": "Karaj",
        "name": "Payam Airport",
    },
    {
        "id": 40,
        "iata": "KKS",
        "country": "IRAN",
        "city": "Kashan",
        "name": "Kashan Airport",
    },
    {
        "id": 41,
        "iata": "KER",
        "country": "IRAN",
        "city": "Kerman",
        "name": "Kerman Airport",
    },
    {
        "id": 42,
        "iata": "KSH",
        "country": "IRAN",
        "city": "Kermanshah",
        "name": "Shahid Ashrafi Esfahani Airport",
    },
    {
        "id": 43,
        "iata": "KHA",
        "country": "IRAN",
        "city": "Khaneh",
        "name": "Khaneh Airport",
    },
    {
        "id": 45,
        "iata": "KHK",
        "country": "IRAN",
        "city": "Kharg Island",
        "name": "Kharg Airport",
    },
    {
        "id": 46,
        "iata": "KHD",
        "country": "IRAN",
        "city": "Khorramabad",
        "name": "Khorramabad Airport",
    },
    {
        "id": 47,
        "iata": "KHY",
        "country": "IRAN",
        "city": "Khoy",
        "name": "Khoy Airport",
    },
    {
        "id": 48,
        "iata": "KIH",
        "country": "IRAN",
        "city": "Kish Island",
        "name": "Kish International Airport",
    },
    {
        "id": 49,
        "iata": "LFM",
        "country": "IRAN",
        "city": "Lamerd",
        "name": "Lamerd Airport",
    },
    {
        "id": 50,
        "iata": "LRR",
        "country": "IRAN",
        "city": "Larestan",
        "name": "Larestan International Airport",
    },
    {
        "id": 51,
        "iata": "LVP",
        "country": "IRAN",
        "city": "Lavan Island",
        "name": "Lavan Airport",
    },
    {
        "id": 54,
        "iata": "MRX",
        "country": "IRAN",
        "city": "Mahshahr",
        "name": "Mahshahr Airport",
    },
    {
        "id": 56,
        "iata": "ACP",
        "country": "IRAN",
        "city": "Maragheh (Sahand)",
        "name": "Sahand Airport",
    },
    {
        "id": 57,
        "iata": "MHD",
        "country": "IRAN",
        "city": "Mashhad",
        "name": "Shahid Hashemi Nejad Airport",
    },
    {
        "id": 60,
        "iata": "NSH",
        "country": "IRAN",
        "city": "Noshahr",
        "name": "Noshahr Airport",
    },
    {
        "id": 61,
        "iata": "PFQ",
        "country": "IRAN",
        "city": "Parsabad",
        "name": "Parsabad-Moghan Airport",
    },
    {
        "id": 62,
        "iata": "GZW",
        "country": "IRAN",
        "city": "Qazvin (Ghazvin)",
        "name": "Qazvin Airport",
    },
    {
        "id": 64,
        "iata": "GSM",
        "country": "IRAN",
        "city": "Qeshm Island",
        "name": "Dayrestan Airport",
    },
    {
        "id": 67,
        "iata": "RJN",
        "country": "IRAN",
        "city": "Rafsanjan",
        "name": "Rafsanjan Airport",
    },
    {
        "id": 68,
        "iata": "RZR",
        "country": "IRAN",
        "city": "Ramsar / Tonekabon",
        "name": "Ramsar Airport",
    },
    {
        "id": 69,
        "iata": "RAS",
        "country": "IRAN",
        "city": "Rasht",
        "name": "Rasht Airport",
    },
    {
        "id": 70,
        "iata": "AFZ",
        "country": "IRAN",
        "city": "Sabzevar",
        "name": "Sabzevar Airport",
    },
    {
        "id": 71,
        "iata": "SDG",
        "country": "IRAN",
        "city": "Sanandaj",
        "name": "Sanandaj Airport",
    },
    {
        "id": 72,
        "iata": "CKT",
        "country": "IRAN",
        "city": "Sarakhs",
        "name": "Sarakhs Airport",
    },
    {
        "id": 74,
        "iata": "SRY",
        "country": "IRAN",
        "city": "Sari",
        "name": "Dasht-e Naz Airport",
    },
    {
        "id": 80,
        "iata": "CQD",
        "country": "IRAN",
        "city": "Shahrekord",
        "name": "Shahrekord Airport",
    },
    {
        "id": 81,
        "iata": "RUD",
        "country": "IRAN",
        "city": "Shahrood",
        "name": "Shahrood Airport",
    },
    {
        "id": 82,
        "iata": "SYZ",
        "country": "IRAN",
        "city": "Shiraz",
        "name": "Shahid Dastghaib International",
    },
    {
        "id": 83,
        "iata": "SYJ",
        "country": "IRAN",
        "city": "Sirjan",
        "name": "Sirjan Airport",
    },
    {
        "id": 84,
        "iata": "SXI",
        "country": "IRAN",
        "city": "Sirri Island",
        "name": "Sirri Island Airport",
    },
    {
        "id": 85,
        "iata": "TCX",
        "country": "IRAN",
        "city": "Tabas",
        "name": "Tabas Airport",
    },
    {
        "id": 86,
        "iata": "TBZ",
        "country": "IRAN",
        "city": "Tabriz",
        "name": "Tabriz International Airport",
    },
    {
        "id": 88,
        "iata": "IKA",
        "country": "IRAN",
        "city": "Tehran",
        "name": "Imam Khomeini International Airport",
    },
    {
        "id": 89,
        "iata": "THR",
        "country": "IRAN",
        "city": "Tehran",
        "name": "Mehrabad International Airport",
    },
    {
        "id": 91,
        "iata": "OMH",
        "country": "IRAN",
        "city": "Urmia",
        "name": "Urmia Airport",
    },
    {
        "id": 92,
        "iata": "YES",
        "country": "IRAN",
        "city": "Yasuj",
        "name": "Yasuj Airport",
    },
    {
        "id": 93,
        "iata": "AZD",
        "country": "IRAN",
        "city": "Yazd",
        "name": "Shahid Sadooghi Airport",
    },
    {
        "id": 94,
        "iata": "ACZ",
        "country": "IRAN",
        "city": "Zabol",
        "name": "Zabol Airport",
    },
    {
        "id": 95,
        "iata": "ZAH",
        "country": "IRAN",
        "city": "Zahedan",
        "name": "Zahedan Airport",
        "is_active": 1,
    },
    {
        "id": 96,
        "iata": "JWN",
        "country": "IRAN",
        "city": "Zanjan",
        "name": "Zanjan Airport",
    },

];


// WEBPACK FOOTER //
// ./src/redux/utils/airports.js